import { useNavigate } from 'react-router-dom';
import './UserTypeSelection.css';
import laborerLogo from '../assets/laborer-logo.webp';
import contractorLogo from '../assets/contractor-logo.webp';

const UserTypeSelection = ({ onSelect }) => {
    const navigate = useNavigate();

    const handleContractorSelect = (role) => {
        sessionStorage.setItem('userRole', role);
        sessionStorage.removeItem('userField');
        navigate('/home');
    };

    const handleLabourSelect = (role) => {
        sessionStorage.setItem('userRole', role);
        navigate('/field-selection');
    }
    return (
        <div className="user-selection-container">
            <h1 className="user-selection-title">Select Your Role</h1>
            <div className="roles-container">
                <div className="role-card" onClick={() => handleLabourSelect("Labour")}>
                    <img src={laborerLogo} alt="Labour Icon" className="role-logo" />
                    <button className="btn">Labour</button>
                </div>
                <div className="role-card" onClick={() => handleContractorSelect("Contractor")}>
                    <img src={contractorLogo} alt="Contractor Icon" className="role-logo" />
                    <button className="btn">Contractor</button>
                </div>
            </div>
        </div>
    );
};

export default UserTypeSelection;
